import {
  Container,
  HeadingText,
  Text,
  SubHeading,
  BulletPoint,
  InternalSubHeading,
  InnerContainer
} from './PrivacyPolicy.style';
export const PrivacyPolicy = () => {
  return (
    <Container>
      <InnerContainer>
        <HeadingText>RoundPe Privacy Policy</HeadingText>
        <SubHeading>Last Updated: July 29, 2022</SubHeading>
        <Text>
          Please read this Policy carefully along with the RoundPe Terms of
          Service (the “Terms”), which describe the terms under which you use
          the Services. If you have any questions, please contact us
          at support@roundpe.com
        </Text>
        <Text>
          RoundPe is a service that simplifies the acceptance of
          cryptocurrencies as payment for goods and services provided by Round
          Finance Inc. (“RoundPe” or “Round” or “we” or “us” or “our”). This
          Privacy Policy (the “Policy”) helps explain how we collect, use,
          store, and protect your information when you use our website at
          www.roundpe.com, the RoundPe service or any RoundPe API or third party
          applications relying on such API, or any other websites, pages,
          features, or content related to the RoundPe service (collectively the
          “Services”).
        </Text>
        <SubHeading>Acceptance of Privacy Policy</SubHeading>
        <Text>
          By accessing and using our Services, you signify your acceptance to
          the terms of this Policy. If you do not agree with or you are not
          comfortable with any aspect of this Policy, you should immediately
          discontinue access or use of our Services.
        </Text>

        <SubHeading>Changes to this Policy</SubHeading>
        <Text>
          We reserve the right to modify this Policy at any time, and when
          required by law, we will notify you of changes to this Policy. If we
          make any material changes we will notify you via the email current on
          your account with us or by means of a notice on our Services prior to
          the change becoming effective.
        </Text>
        <Text>
          RoundPe may provide additional &quot;just-in-time&quot; disclosures or
          additional information about the data collection, use and sharing
          practices of specific Services. These notices may supplement or
          clarify our privacy practices or may provide you with additional
          choices about how we process your personal information.
        </Text>
        <SubHeading>Scope of this Privacy Policy</SubHeading>
        <Text>
          This Privacy Policy only applies to non-custodial RoundPe Services.
          Please review our Retail Privacy Policy to understand how RoundPe
          collects, uses and shares personal information of its custodial
          customers when performing custodial RoundPe Services.
        </Text>
        <SubHeading>Our Relationship to You</SubHeading>
        <Text>
          For you to understand our data protection obligations and your rights
          to your personal information under this Policy, it is important that
          you identify which relationship(s) you have with us. Round Finance
          Inc. (“RoundPe”) has the following relationships:
        </Text>
        <BulletPoint>
          {' '}
          A “User” is an individual providing personal information to us via our
          website or other services, products or platforms, such as by signing
          up for our newsletter or making an account and posting on the forums.
          RoundPe is a “data controller” in relationship to its Users.{' '}
        </BulletPoint>
        <BulletPoint>
          A “Customer” is a specific type of User that has engaged us to act as
          an agent (or, as a “Data Processor”) by obtaining our Services.
          RoundPe is a “data processor” in relationship to Customers.
        </BulletPoint>
        <BulletPoint>
          RoundPe does not have a direct relationship with Customers’ End Users.
          A “Customer End User” is an individual that provides their personal
          information to Customers. We do not control the purposes or the means
          by which this personal information is collected, and we are not in a
          direct relationship with Customer End Users.
        </BulletPoint>
        <Text>
          Hereinafter we may refer to Customers and Users collectively as “you.”
        </Text>
        <SubHeading>Information We Collect</SubHeading>
        <Text>
          We receive or collect personal information when we operate and provide
          our Services, including when you install, access, or use our Services.
          Personal information is data that can be used to identify you directly
          or indirectly, or to contact you. Our Policy governs all personal
          information we collect about you and obtain from third party sources.
          This Policy does not apply to anonymized information as it cannot be
          used to identify you.
        </Text>
        <Text>
          Generally, we collect information to provide you with our Services.
          Except as described in this Policy, we will not sell, lease, rent or
          loan your personal information to any third party without your prior
          consent.
        </Text>
        <SubHeading>Information you provide</SubHeading>
        <BulletPoint>
          Your Account Information - To create a RoundPe account, you must
          provide us with an email address and secure password.
        </BulletPoint>
        <BulletPoint>
          Your Products and Services - We retain information submitted by you
          when you create each payment button or donation button, which may
          include your product or service name, price and description.
        </BulletPoint>
        <BulletPoint>
          Your Cryptocurrency Addresses - We retain your public cryptocurrency
          addresses generated in the course of your use of the Service.
        </BulletPoint>
        <BulletPoint>
          Your Cryptocurrency Addresses - We retain your public cryptocurrency
          addresses generated in the course of your use of the Service.
        </BulletPoint>
        <BulletPoint>
          Customer Support - We collect any additional information you disclose
          to our customer support team.
        </BulletPoint>
        <SubHeading>Information we collect from our affiliates</SubHeading>
        <Text>
          Our “family of companies” is the group of companies related to us by
          common control or ownership (“Affiliates”). In accordance with
          applicable law, we may obtain information about you from our
          Affiliates in the normal course of business to provide the Services
          and Affiliates’ Services to you (e.g., convert cryptocurrency into
          fiat and make withdrawals into your bank account).
        </Text>
        <SubHeading>Automatically collected information</SubHeading>
        <BulletPoint>
          Metrics and Performance Data - We collect service-related, diagnostic,
          and performance information. This includes high level information
          about your activity (such as how you use our Services and how you
          interact with others using our Services), and diagnostic, crash,
          website, and performance logs and reports.
        </BulletPoint>
        <BulletPoint>
          Device and Connection Information - We collect device-specific
          information when you install, access, or use our Services, including
          your IP address and your web-browser software.
        </BulletPoint>
        <SubHeading>How We Use the Information We Collect</SubHeading>
        <Text>
          Our primary purpose in collecting information is to help us operate,
          provide, improve, customize, support, and market our Services.We may
          use your information:
        </Text>
        <InternalSubHeading>To provide RoundPe Services</InternalSubHeading>
        <Text>
          We process your personal information to provide the Services. For
          example, if you want to use our Services to accept Digital Currency on
          your website, we require that you provide us with your email address
          and a password. We cannot provide you with Services without such
          information.
        </Text>
        <InternalSubHeading>
          To provide Service communications
        </InternalSubHeading>
        <Text>
          We send administrative or account-related information to you to keep
          you updated about our Services, inform you of relevant security issues
          or updates, or provide other transaction-related information. Without
          such communications, you may not be aware of important developments
          relating to your account that may affect how you can use our Services.
        </Text>
        <InternalSubHeading>To provide customer service</InternalSubHeading>
        <Text>
          We process your personal information when you contact us to resolve
          any questions, disputes, or to troubleshoot problems. Without
          processing your personal information for such purposes, we cannot
          respond to your requests and ensure your uninterrupted use of the
          Services.
        </Text>
        <InternalSubHeading>To ensure quality control</InternalSubHeading>
        <Text>
          We process your personal information for quality control and staff
          training to make sure we continue to provide you with accurate
          information. If we do not process personal information for quality
          control purposes, you may experience issues on the Services such as
          inaccurate transaction records or other interruptions.
        </Text>
        <Text>
          Designated Countries: For individuals who reside in the United
          Kingdom, European Economic Area or Switzerland (collectively the
          “Designated Countries”), pursuant to EU General Data Protection
          Regulation (“GDPR”) or any equivalent legislation (collectively “DC
          Data Protection Laws”), we process this personal information based on
          our contract with you.
        </Text>
        <InternalSubHeading>
          For research and development purposes
        </InternalSubHeading>
        <Text>
          We process your personal information to better understand you and, if
          applicable, your end-users and the way you use and interact with our
          Services. In addition, we use such information to customize, measure,
          and improve our Services and the content and layout of our website and
          applications, and to develop new Services. Without such processing, we
          cannot ensure your continued enjoyment of our Services.
        </Text>
        <Text>
          Designated Countries: Pursuant to DC Data Protection Laws, we process
          this personal information to satisfy our legitimate interests as
          described above.
        </Text>
        <InternalSubHeading>
          To enhance your website experience
        </InternalSubHeading>
        <Text>
          We process your personal information to provide a personalized
          experience, and implement the preferences you request. Without such
          processing, we may not be able to ensure your continued enjoyment of
          part or all of our Services.
        </Text>
        <Text>
          Designated Countries: Pursuant to DC Data Protection Laws, we process
          this personal information to satisfy our legitimate interests as
          described above.
        </Text>
        <InternalSubHeading>
          To facilitate corporate acquisitions, mergers, or transactions
        </InternalSubHeading>
        <Text>
          We may process any information regarding your account and use of our
          Services as is necessary in the context of corporate acquisitions,
          mergers, or other corporate transactions. You have the option of
          closing your account if you do not wish to have your personal
          information processed for such purposes.
        </Text>
        <Text>
          Designated Countries: Pursuant to DC Data Protection Laws, we process
          this personal information to satisfy our legitimate interests as
          described above.
        </Text>
        <InternalSubHeading>
          To engage in marketing activities
        </InternalSubHeading>
        <Text>
          Based on your communication preferences, we may send you marketing
          communications to inform you about relevant product offers and
          services; to deliver targeted marketing; and to provide you with
          promotional offers based on your communication preferences. We use
          information about your usage of our Services and your contact
          information to provide marketing communications. You can opt-out of
          our marketing communications at any time.
        </Text>
        <Text>
          Designated Countries: Pursuant to DC Data Protection Laws, we process
          this personal information based on your consent or legitimate interest
          to the extent permitted by DC Data Protection Laws. To the extent we
          can rely on legitimate interest under the applicable law, we will only
          send you information about our Services that are similar to those
          which were the subject of a previous sale or negotiations of a sale to
          you. You may raise such objections with regard to initial or further
          processing for purposes of direct marketing, at any time and free of
          charge.
        </Text>
        <Text>
          We will not use your information for purposes other than those
          purposes we have disclosed to you. From time to time we may request
          your permission to allow us to share your personal information with
          third parties. You may opt out of having your personal information
          shared with third parties, or from allowing us to use your personal
          information for any purpose that is incompatible with the purposes for
          which we originally collected it or subsequently obtained your
          authorization. If you choose to limit the use of your personal
          information, certain features or Services may not be available to you.
        </Text>
        <SubHeading>Communications</SubHeading>
        <Text>
          We may send you communications that are related to your account or
          will be related to our Services or information we believe interests
          you. In the event we send any communication to you which is not
          related specifically to your account, we will provide you with an
          &quot;unsubscribe&quot; mechanism through which you may opt out of
          receiving other similar messages in the future.
        </Text>
        <SubHeading>
          How Your Information Is Shared With Customer End Users
        </SubHeading>
        <Text>
          If you use your account in a transaction with your Customer End User,
          that Customer End User will have access to an address associated with
          your public key allowing them to pay for their purchases.
        </Text>
        <SubHeading>
          How We Share Information With Affiliates and Third Parties
        </SubHeading>
        <Text>
          We work with our Affiliates and third-party providers to help us
          operate, provide, improve, customize, support, and market our
          Services. For example, we work with companies to provide our
          infrastructure, delivery, and other systems. These providers may
          provide us information about you in certain circumstances.
        </Text>
        <Text>
          We will also share information with our Affiliates in the normal
          course of business to provide the Services and Affiliate services.
        </Text>
        <Text>
          We may also share information with law enforcement, government
          officials, Affiliates or other third parties when:
        </Text>
        <BulletPoint>
          We are compelled to do so by a subpoena, court order, or similar legal
          procedure; or
        </BulletPoint>
        <BulletPoint>
          We believe in good faith that the disclosure of personal information
          is necessary to prevent physical harm or financial loss, to report
          suspected illegal activity or to investigate violations of our Terms.
        </BulletPoint>
        <SubHeading>How We Use Cookies</SubHeading>
        <Text>
          When you access our Services, we or companies we work with may place
          cookies on your computer or other devices. These technologies help us
          better understand user behavior, and inform us about which parts of
          our websites people have visited.
        </Text>
        <SubHeading>Do-Not-Track</SubHeading>
        <Text>
          Some Internet browsers - like Internet Explorer, Firefox, and Safari -
          include the ability to transmit &quot;Do Not Track&quot; or
          &quot;DNT&quot; signals. Since uniform standards for &quot;DNT&quot;
          signals have not been adopted, our Services do not currently process
          or respond to &quot;DNT&quot; signals.
        </Text>
        <SubHeading>Children</SubHeading>
        <Text>
          We do not knowingly request or collect personal information from any
          person under the age of 18. If a user submitting personal information
          is suspected of being younger than 18 years of age, RoundPe will
          require the user to close his or her account and will not allow
          continued use of the Services. We will also take steps to delete the
          information as soon as possible. Please notify us if you know of any
          individuals under the age of 18 using our Services so we can take
          action to prevent access to our Services.
        </Text>
        <SubHeading>California Privacy Rights</SubHeading>
        <Text>
          If you are a California resident, you have the right to request
          information from us regarding the manner in which we share certain
          categories of your personal information with third parties for the
          third parties’ direct marketing purposes. California law provides that
          you have the right to submit a request to us at our designated address
          and receive the following information: (a) the categories of
          information we disclosed to third parties for the third parties’
          direct marketing purposes during the preceding calendar year; and (b)
          the names and addresses of third parties that received such
          information, or if the nature of their business cannot be determined
          from the name, then examples of the products or services marketed.
        </Text>
        <Text>
          You are entitled to receive a copy of this information in a
          standardized format and the information will not be specific to you
          individually. You may make such a request by emailing
          support@fancraze.com.
        </Text>
        <SubHeading>
          Access and Modification of Your Personal Information
        </SubHeading>
        <Text>
          You may contact us at support@fancraze.com to access the personal
          information we hold about you. If any of the information is
          inaccurate, you may rectify such information. We reserve the right to
          limit your access or modifications if your requests are too frequent
          and/or burdensome.
        </Text>
        <Text>
          For individuals residing in Designated Countries, please refer to the
          “International Users” section below.
        </Text>
        <SubHeading>Security Safeguards</SubHeading>
        <Text>
          We maintain, and require our service providers to maintain,
          appropriate physical, technical and administrative safeguards to
          protect the security and confidentiality of the personal information
          you entrust to us.
        </Text>
        <Text>
          However, we cannot guarantee that loss, misuse, unauthorized
          acquisition, or alteration of your data will not occur. Please
          recognize that you play a vital role in protecting your own personal
          information. When registering with our Services, it is important to
          choose a password of sufficient length and complexity, to not reveal
          this password to any third-parties, and to immediately notify us if
          you become aware of any unauthorized access to or use of your account.
        </Text>
        <Text>
          Furthermore, we cannot ensure or warrant the security or
          confidentiality of information you transmit to us or receive from us
          by Internet or wireless connection, including email, phone, or SMS,
          since we have no way of protecting that information once it leaves and
          until it reaches us. If you have reason to believe that your data is
          no longer secure, please contact us at the email address, mailing
          address or telephone number listed at the end of this Privacy Policy.
        </Text>
        <SubHeading>Retention</SubHeading>
        <Text>
          We limit our retention of your personal information to the only as
          long as necessary to fulfil the purposes for which we collected it,
          including for the purposes of satisfying any legal, accounting, or
          reporting obligations or to resolve disputes. While retention
          requirements vary by jurisdiction, information about our typical
          retention periods for different aspects of your personal information
          are described below.
        </Text>
        <BulletPoint>
          Email address for marketing purposes is retained on an ongoing basis
          until you un-subscribe. Thereafter we will add your details to our
          suppression list indefinitely.
        </BulletPoint>
        <BulletPoint>
          Information collected via technical means such as cookies, webpage
          counters and other analytics tools is kept for a period of up to one
          year from expiry of the cookie.
        </BulletPoint>
        <Text>
          Please contact us if you have questions about retention periods for a
          particular aspect of your personal information which is not detailed
          above.
        </Text>
        <SubHeading>International Transfers of Personal Information</SubHeading>
        <Text>
          As a global entity, RoundPe may store, transfer, and otherwise process
          your personal information in countries outside of the country of your
          residence, including the United States and possibly other countries.
          The data protection laws of such countries may not be as protective as
          the laws of the country in which you reside. To ensure that personal
          information is adequately protected when transferred outside the
          Designated Countries, RoundPe relies on Standard Contractual Clauses
          approved by the European Commission.
        </Text>
        <SubHeading>International Users</SubHeading>
        <Text>
          This section only applies to individuals residing in a Designated
          Country.
        </Text>
        <BulletPoint>
          Legal bases for processing personal information. Our legal bases for
          processing are described in the sections above entitled “How We Use
          the Information We Collect” and “Information We Collect.” We may
          process your personal information if you consent to the processing, to
          satisfy our legal obligations, if it is necessary to carry out our
          obligations arising from any contracts we entered with you or to take
          steps at your request prior to entering into a contract with you, or
          for our legitimate interests to protect our property, rights or safety
          of RoundPe, our customers or others.
        </BulletPoint>
        <BulletPoint>
          Direct Marketing. If you are located in the Designated Countries and
          are a current customer, we will only contact you by electronic means
          (email or SMS) with information about our Services that are similar to
          those which were the subject of a previous sale or negotiations of a
          sale to you. If you are a new customer and located in the Designated
          Countries, we will contact you by electronic means for marketing
          purposes only if you have consented to such communication. If you no
          longer want us to use your personal information in this way, or to
          pass your personal information on to third parties for marketing
          purposes, please opt out of the emails by clicking the “unsubscribe”
          link in the footer of our email or contact us at support@roundpe.com
          .You may raise such objections with regard to initial or further
          processing for purposes of direct marketing, at any time and free of
          charge. Direct marketing includes any communications to you that are
          only based on advertising or promoting products and services
        </BulletPoint>
        <BulletPoint>
          Individual Rights. Residents of Designated Countries have the
          following rights, which can be exercised by contacting us
          at support@roundpe.com so that we may consider your request under
          applicable law.
        </BulletPoint>
        <BulletPoint>
          Right to withdraw consent. You have the right to withdraw your consent
          to the processing of your personal information collected on the basis
          of your consent at any time. Your withdrawal will not affect the
          lawfulness of RoundPe’s processing based on consent before your
          withdrawal.{' '}
        </BulletPoint>
        <BulletPoint>
          Right of access to and rectification of your personal information. You
          have a right to request that we provide you a copy of your personal
          information held by us. This information will be provided without
          undue delay subject to some fee associated with gathering of the
          information (as permitted by law), unless such provision adversely
          affects the rights and freedoms of others. You may also request us to
          rectify or update any of your personal information held by us that is
          inaccurate.
        </BulletPoint>
        <BulletPoint>
          Right to erasure. You have the right to request erasure of your
          personal information that: (a) is no longer necessary in relation to
          the purposes for which it was collected or otherwise processed; (b)
          was collected in relation to processing that you previously consented,
          but later withdraw such consent; or (c) was collected in relation to
          processing activities to which you object, and there are no overriding
          legitimate grounds for our processing. If we have made your personal
          information public and are obliged to erase the personal information,
          we will, taking account of available technology and the cost of
          implementation, take reasonable steps, including technical measures,
          to inform other parties that are processing your personal information
          that you have requested the erasure of any links to, or copy or
          replication of your personal information. The above is subject to
          limitations by relevant data protection laws.
        </BulletPoint>
        <BulletPoint>
          Right to data portability. If we process your personal information
          based on a contract with you or based on your consent, or the
          processing is carried out by automated means, you may request to
          receive your personal information in a structured, commonly used and
          machine-readable format, and to have us transfer your personal
          information directly to another “controller”, where technically
          feasible, unless exercise of this right adversely affects the rights
          and freedoms of others. A “controller” is a natural or legal person,
          public authority, agency or other body which, alone or jointly with
          others, determines the purposes and means of the processing of your
          personal information.
        </BulletPoint>
        <BulletPoint>
          Right to restriction of or processing. You have the right to restrict
          or object to us processing your personal information where one of the
          following appliesRestricted personal information shall only be
          processed with your consent or for the establishment, exercise or
          defense of legal claims or for the protection of the rights of another
          natural or legal person or for reasons of important public interest.
          We will inform you if the restriction is lifted.
          <BulletPoint>
            You contest the accuracy of your personal information that we
            processed. In such instances, we will restrict processing during the
            period necessary for us to verify the accuracy of your personal
            information.
          </BulletPoint>
          <BulletPoint>
            The processing is unlawful and you oppose the erasure of your
            personal information and request the restriction of its use instead.
          </BulletPoint>
          <BulletPoint>
            We no longer need your personal information for the purposes of the
            processing, but it is required by you to establish, exercise or
            defense of legal claims.
          </BulletPoint>
          <BulletPoint>
            You have objected to processing, pending the verification whether
            the legitimate grounds of our processing override your rights.
          </BulletPoint>
        </BulletPoint>
        <BulletPoint>
          Notification of erasure, rectification and restriction. We will
          communicate any rectification or erasure of your personal information
          or restriction of processing to each recipient to whom your personal
          information has been disclosed, unless this proves impossible or
          involves disproportionate effort. We will inform you about those
          recipients if you request this information.
        </BulletPoint>
        <BulletPoint>
          Right to object to processing. Where the processing of your personal
          information is based on consent, contract or legitimate interests you
          may restrict or object, at any time, to the processing of your
          personal information as permitted by applicable law. We can continue
          to process your personal information if it is necessary for the
          defense of legal claims, or for any other exceptions permitted by
          applicable law.
        </BulletPoint>
        <BulletPoint>
          Automated individual decision-making, including profiling. You have
          the right not to be subject to a decision based solely on automated
          processing of your personal information, including profiling, which
          produces legal or similarly significant effects on you, save for the
          exceptions applicable under relevant data protection laws.
        </BulletPoint>
        <BulletPoint>
          Right to lodge a complaint. If you believe that we have infringed your
          rights, we encourage you to contact us first at support@roundpe.com so
          that we can try to resolve your issue or dispute informally. You also
          have a right to lodge a complaint with a competent supervisory
          authority situated in a Member State of your habitual residence, place
          of work, or place of alleged infringement.
        </BulletPoint>
        <BulletPoint>
          Storage of your personal information. We will try to limit the storage
          of your personal information to the extent that storage is necessary
          to serve the purpose(s) for which the personal information was
          processed, to resolve disputes, enforce our agreements, and as
          required or permitted by law.
        </BulletPoint>
        <BulletPoint>
          Data Protection Officer: You may reach our Data Protection Officer
          at support@roundpe.com
        </BulletPoint>
        <Text>
          Your rights to personal information are not absolute. Access may be
          denied when:
        </Text>
        <BulletPoint>
          Denial of access is required or authorized by law;
        </BulletPoint>
        <BulletPoint>
          Granting access would have a negative impact on other&apos;s privacy;
        </BulletPoint>
        <BulletPoint>To protect our rights and properties; and</BulletPoint>
        <BulletPoint>Where the request is frivolous or vexatious.</BulletPoint>
        <SubHeading>Contact Us</SubHeading>
        <Text>
          If you have any questions about our Privacy Policy, please do not
          hesitate to contact us at support@roundpe.com, or by mailing us at
          Round Finance Inc. 400 East 66th Street, Apt 21C, New York, NY 10065
        </Text>
      </InnerContainer>
    </Container>
  );
};
